import React from 'react';
import SettingsCard from './SettingsCard';
import Form from '../../../components/forms/utils/Form';
import { Switch } from '../../../components/lists/listComponents/Switch';
import { useCurrentUser } from '../../../utils/CurrentUserContext';
import { useMutation, useQuery } from '@apollo/client';
import { GET_NOTIFICATION_SETTINGS, SAVE_NOTIFICATION_SETTINGS } from '../../../utils/api/notification';
import Spinner from '../../../components/icons/Spinner';
import { NotificationType } from '../../../__generated__/graphql';

const Notifications = () => {
  const {user} = useCurrentUser()

  const {loading, data} = useQuery(GET_NOTIFICATION_SETTINGS)
  const [saveSettings, {loading: saving}] = useMutation(SAVE_NOTIFICATION_SETTINGS, {
    refetchQueries: ['NotificationSettingsMany']
  })

  const enabled = !loading && data.settings.find(({userId} : {userId: string}) => userId === user._id)
  const handleSubmit = async ({enabled}: any, _: any) => {
    const settings = data.settings
    .filter(({userId}: {userId: string}) => userId !== user._id)
    .map(({userId}: {userId: string}) => ({userId, notifications: [NotificationType.NewCampaignApproval]}))
  
    if (enabled) {
      settings.push({
        userId: user._id,
        notifications: [NotificationType.NewCampaignApproval]
      })
    }

    await saveSettings({variables: {record: {settings}}})
  }
  return (
    <SettingsCard
    title="Notifications"
    description="Select what kind of notifications you want to receive"
  >
    {loading && <Spinner />}
    {!loading &&  <Form
          submitButtonText="Save"
          loading={saving}
          onSubmit={handleSubmit}
          defaultValues={{
            enabled: enabled
          }}
      >
        <div className='flex p-6 justify-between'>
          <div>
            <div className='text-md leading-6 font-medium text-gray-900'>Campaign approval</div>
            <div className='mt-2 text-sm text-gray-700'>Get an email every time a campaign needs your approval</div>
          </div>

          <Switch name='enabled'/>
        </div>
        
      </Form> 
    }
    </SettingsCard>
  );
};

export default Notifications;

